import React from 'react';
import BaseTextLink from './BaseTextLink';
import './style/SimpleTextLink.scss';

export default function SimpleTextLink({ className, ...restProps }) {
  const classes = ['SimpleTextLink', className];
  return <BaseTextLink className={classes.join(' ')} {...restProps} />;
}
